
import { Injectable, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LanguageSettings {

  java = 'Java';
  swift = 'Swift';
  javaScript = 'JavaScript';
  dart = 'Dart';

  languageSelectedChange: EventEmitter<string> = new EventEmitter();

  languageSelected = this.java;

  constructor() { }

  setJava() {
    this.setSelectedLanguage(this.java);
  }

  setSwift() {
    this.setSelectedLanguage(this.swift);
  }

  setJavaScript() {
      this.setSelectedLanguage(this.javaScript);
  }

  setDart() {
    this.setSelectedLanguage(this.dart);
  }

  setSelectedLanguage(lang: string) {
      this.languageSelected = lang;
      this.languageSelectedChange.emit(lang);
  }

  getSelectedLanguage() {
    return this.languageSelected;
  }

  getAllLanguages() {
      return new Array( this.java, this.swift, this.javaScript, this.dart)
  }

  getLanguageChangeEmitter() {
    return this.languageSelectedChange;
  }

}
